export default {
	"fileUploadComp": {
		"downloadZip": "ดาวน์โหลดแพ็คเกจ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/components/FileUploadComp/FileUploadComp.js